window.default = new (function (){
    this.index = function(){

    }
    
  });
  
  
   